let map = {
    $canvas: $("#js-mapCanvas"),
    $form: $("#js-mapForm"),
    $postalCode: $('#js-mapPostalCode'),
    $lat: $('#js-mapLat'),
    $lng: $('#js-mapLng'),
    $numReports: $('#js-mapNumReports'),
    $province: $('#js-mapProvince'),
    $submit: $('#js-mapSubmit'),
    $ui: $('#js-mapUi'),
    $uiToggle: $('#js-mapUiToggle'),
    $yearMonth: $('#js-mapYearMonth'),
    geocoder: null,
    hasRegion: false,
    infoBoxes: [],
    infoBoxReady: false,
    infoBoxTemplate: _.template($('#js-mapInfoBox').html()),
    markers: [],
    map: null,
    mapReady: true,
    reports: [],

    clearMarkers() {
        this.markers.forEach((marker) => marker.setMap(null))
    },

    init() {
        // Load Google Maps API
        app.modules.googleMaps.load(this.initMap.bind(this))

        // Init UI event handlers
        this.$form.on('ajaxForm:success', this.onFormSuccess.bind(this))
        this.$postalCode.on('blur', this.onPostalCodeBlur.bind(this))
        this.$province.on('change', this.onProvinceChange.bind(this))
        this.$uiToggle.on(app.eventNameClick, this.onUiToggleClick.bind(this))
        
        // Load reports
        setTimeout(this.load.bind(this), 50)
    },

    initMap() {
        // Load InfoBox
        $.getScript('/assets/js/lib/infobox_packed.js', this.onLoadInfoBox.bind(this))

        // Init geocoder
        this.geocoder = new google.maps.Geocoder()

        // Init map
        this.map = new google.maps.Map(this.$canvas.get(0), {
            center: new google.maps.LatLng(52.132633, 5.291266),
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            streetViewControl: false,
            styles: app.modules.mapStyles.styles,
            zoom: 7,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
        })

        // All done!
        this.mapReady = true
    },

    load() {
        if (!this.mapReady) {
            return setTimeout(this.load.bind(this), 50)
        }

        this.$form.trigger('submit')
    },

    onFormSuccess(e, data) {
        let bounds
        let label
        let latLng

        // Update number of reports
        label = this.$numReports.attr('data-label-' + (data.num_reports === 1 ? 'one' : 'more'))
        this.$numReports.text(data.num_reports + ' ' + label)

        // Clear markers
        this.clearMarkers()

        // Set marker bounds
        bounds = new google.maps.LatLngBounds()

        // Set markers
        data.reports.forEach((report) => {
            latLng = new google.maps.LatLng(
                report.location_lat,
                report.location_lng
            )

            this.setMarker(report, latLng)
            bounds.extend(latLng)
        })

        // Zoom map to bounds
        // this.map.fitBounds(bounds)
    },

    onLoadInfoBox() {
        this.infoBoxReady = true
    },

    onPostalCodeBlur(e) {
        let postalCode
        let query

        postalCode = _.trim(this.$postalCode.val())
        query = `${postalCode}, Nederland`

        // Hide validation icon
        this.$postalCode.parent().removeClass('is-error is-ok')

        if (postalCode === '') {
            // Clear latitude and longitude
            this.$lat.val('')
            this.$lng.val('')

            // Re-enable province select
            this.$province.prop('disabled', false)
        } else {
            // Disable submit button
            this.$submit.prop('disabled', true)

            // Find geo coordinates for query
            this.geocoder.geocode({address: query}, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    // Write latitude and longitude
                    this.$lat.val(results[0].geometry.location.lat())
                    this.$lng.val(results[0].geometry.location.lng())

                    // Disable province select
                    this.$province.prop('disabled', true)

                    // Re-enable submit button
                    this.$submit.prop('disabled', false)

                    // Show validation icon
                    this.$postalCode.parent().addClass('is-ok')
                } else {
                    // Show validation icon
                    this.$postalCode.parent().addClass('is-error')

                    // Re-enable province select
                    this.$province.prop('disabled', false)
                }

                this.updateYearMonth()
            })
        }
    },

    onProvinceChange(e) {
        this.updateYearMonth()
    },

    onUiToggleClick(e) {
        e.preventDefault()
        this.$ui.toggleClass('is-visible')
    },

    setMarker(report, latLng) {
        let infoBox;
        let marker

        marker = new google.maps.Marker({
            icon: {
                anchor: new google.maps.Point(8, 8),
                scaledSize: new google.maps.Size(16, 16),
                size: new google.maps.Size(32, 32),
                url: '/assets/img/marker-small.png'
            },
            map: this.map,
            position: latLng
        })

        infoBox = new InfoBox({
            boxClass: 'map-infoBox',
            closeBoxMargin: "0 0 8px 8px",
            closeBoxURL: "/assets/img/close.svg",
            content: this.infoBoxTemplate({report: report}),
            disableAutoPan: true,
            infoBoxClearance: new google.maps.Size(8, 8),
            isHidden: false,
            maxWidth: 300,
            position: latLng
        });

        var _map = this.map;

        google.maps.event.addListener(marker, 'click', (e) => {
            this.infoBoxes.forEach((infoBox) => infoBox.close())
            infoBox.open(this.map, e.target)
        })

        this.infoBoxes.push(infoBox)
        this.markers.push(marker)
    },

    updateYearMonth() {
        let hasRegion

        hasRegion = (this.$lat.val() !== '') || (this.$province.val() !== 0)
        this.$yearMonth.children(`option[value='all']`).prop('disabled', !hasRegion)
    }    
}

export default map